/** Compact display for combat numbers. Internal values stay precise. */
export function formatCompactNumber(value: number): string {
  const n = Math.max(0, value)
  if (n < 1000) {
    return Number.isInteger(n) ? String(n) : n.toFixed(1).replace(/\.0$/, '')
  }
  if (n < 1_000_000) {
    const k = n / 1000
    return `${k >= 100 ? k.toFixed(0) : k.toFixed(1).replace(/\.0$/, '')}K`
  }
  const m = n / 1_000_000
  return `${m >= 100 ? m.toFixed(0) : m.toFixed(1).replace(/\.0$/, '')}M`
}
